import resetPasswordEpic from './epics/reset-password.epic';

export default { resetPasswordEpic };
